import CardButton from "../usercontrols/CardButton";

const UserManagement = () => {
  return (
    <>
      <div className="page-title">
        <h1>User Management</h1>
      </div>
      <div className="cards-grp">
        <CardButton
          dataTestid="AddEditUser"
          route="/user/add"
          icon="fi-ss-user-add"
          title="Add a user"
          tooltip="Add a new user for the company"
          data={{ mode: "Add" }}
        />
        <CardButton
          dataTestid="ViewUser"
          route="/users/all"
          icon="fi-ss-user-pen"
          title="View and edit users"
          tooltip="Update user"
        />
      </div>
    </>
  );
};

export default UserManagement;
